import { put, takeLatest, call } from 'redux-saga/effects';
import {
  errorTalentOnboardingSubmit,
  loadedTalentOnboardingSubmit,
  loadTalentOnboardingSubmit,
  talentOnboardingCompleted,
} from '../actions/talentOnboardingActions';
import { loadedCreateJobAlert, submitJobAlertCtaClicked } from '../actions/jobAlertActions';
import NetworkAPI from '../../api/NetworkAPI';

export function* loadTalentOnboardingSubmitEvent({ payload }) {
  const { onboarding, network } = payload;
  try {
    const { data: jobAlert, meta } = yield call(NetworkAPI.saveOnboardingData, network.id, onboarding);
    yield put(loadedTalentOnboardingSubmit(meta));

    if (jobAlert) {
      const { id, attributes } = jobAlert;
      yield put(loadedCreateJobAlert({ jobAlert: { id, ...attributes } }));
      yield put(submitJobAlertCtaClicked({ network, source: 'talent_network_signup' }));
    }

    yield put(talentOnboardingCompleted({ ...meta, network }));
  } catch (error) {
    yield put(errorTalentOnboardingSubmit());
  }
}

export default function* submitOnboardingRequestWatcher() {
  yield takeLatest(loadTalentOnboardingSubmit().type, loadTalentOnboardingSubmitEvent);
}
